import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Select from "react-select";
import { campaignAction } from "../../store/campaign-store";
import Input from "../UI/Input";

const LeftEditor = (props) => {
  const [isColor, setIsColor] = useState(false);
  const [leftData, setLeftData] = useState({
    text: "",
    color: "",
    fontSize: "",
    fontFamily: "montserrat",
  });

  const options = [
    { value: "Lato", label: "Lato" },
    { value: "Montserrat", label: "Montserrat" },
    { value: "Roboto", label: "Roboto" },
    { value: "Oswald", label: "Oswald" },
    { value: "Poppins", label: "Poppins" },
    { value: "Quicksand", label: "Quicksand" },
  ];

  const { show, toggleLeftshow, length } = props;

  const dispatch = useDispatch();
  const single_layer = useSelector((state) => state.campaign.single_layer);

  // console.log(single_layer);
  // const video_data = useSelector((state) => state.campaign.video_data);
  // const single_slide_data = useSelector(
  //   (state) => state.campaign.single_slide_data
  // );
  const active_slide_name = useSelector(
    (state) => state.campaign.active_slide_name
  );

  const editSlideData = useSelector((state) => state.campaign.editSlideData);

  useEffect(() => {
    // console.log(single_layer);
    if (show) {
      setLeftData({
        text: single_layer.text,
        layerName: single_layer.name,
        color: single_layer.color !== undefined ? single_layer.color : "",
        fontSize:
          single_layer.fontSize !== undefined ? single_layer.fontSize : "",
        fontFamily:
          single_layer.fontFamily !== undefined
            ? single_layer.fontFamily
            : "montserrat",
      });

      // if (single_layer.name && single_layer.name.includes("hexColor")) {
      //   setLeftData({
      //     ...leftData,
      //     color: single_layer.text !== undefined ? single_layer.text : "",
      //   });
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  useEffect(() => {
    // if (
    //   active_slide_name === "slide_1" ||
    //   active_slide_name === "slide_2" ||
    //   active_slide_name === "slide_3" ||
    //   active_slide_name === "slide_4" ||
    //   active_slide_name === "slide_5"
    // ) {
    if (single_layer.name && single_layer.name.includes("hexColor")) {
      setIsColor(true);
    } else {
      setIsColor(false);
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active_slide_name, single_layer]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // console.log(single_layer);
    // console.log(leftData);

    // return false;
    const new_layer_data = { ...single_layer, ...leftData };

    // console.log(new_layer_data);
    // return false;
    await dispatch(campaignAction.setSingleLayerData({ data: new_layer_data }));

    await dispatch(
      campaignAction.setSingleSlideData({ layer_name: single_layer.name })
    );

    // return false;
    // console.log(single_layer);

    dispatch(campaignAction.appendVideoData());

    // return false;
    // if (
    //   active_slide_name === "slide_1" ||
    //   active_slide_name === "slide_2" ||
    //   active_slide_name === "slide_3" ||
    //   active_slide_name === "slide_4" ||
    //   active_slide_name === "slide_5" ||
    //   active_slide_name === "slide_6"
    // ) {
    var newData = { ...editSlideData };

    console.log(leftData);
    if (single_layer.name === "Title") {
      newData.text = leftData.text.replace("  ", "<br />");
    }

    if (single_layer.name === "hello") {
      newData.hello = leftData.text;
    }

    if (single_layer.name === "hey") {
      newData.hey = leftData.text;
    }

    if (single_layer.name === "home A") {
      newData.home_a = leftData.text;
    }

    if (single_layer.name === "home B") {
      newData.home_b = leftData.text;
    }

    if (single_layer.name === "home C") {
      newData.home_c = leftData.text;
    }

    if (single_layer.name === "number") {
      newData.number = leftData.text;
    }

    if (single_layer.name === "problem A") {
      newData.problem_a = leftData.text;
    }

    if (single_layer.name === "problem B") {
      newData.problem_b = leftData.text;
    }

    if (single_layer.name === "problem C") {
      newData.problem_c = leftData.text;
    }

    if (single_layer.name === "problem D") {
      newData.problem_d = leftData.text;
    }

    if (single_layer.name === "trust A") {
      newData.trust_a = leftData.text;
    }

    if (single_layer.name === "trust B") {
      newData.trust_b = leftData.text;
    }

    if (single_layer.name === "trust C") {
      newData.trust_c = leftData.text;
    }

    if (single_layer.name === "resolve A") newData.resolve_a = leftData.text;
    if (single_layer.name === "resolve B") newData.resolve_b = leftData.text;
    if (single_layer.name === "resolve C")
      newData.resolve_c = leftData.text.replace("  ", "<br />");

    if (single_layer.name === "resolve D")
      newData.resolve_d = leftData.text.replace("  ", "<br />");

    if (
      single_layer.name === "solution A" ||
      single_layer.name === "solutions A"
    )
      newData.solution_a = leftData.text;
    if (
      single_layer.name === "solution B" ||
      single_layer.name === "solutions B"
    )
      newData.solution_b = leftData.text;
    if (
      single_layer.name === "solution C" ||
      single_layer.name === "solutions C"
    )
      newData.solution_c = leftData.text;
    if (single_layer.name === "solution D") newData.solution_d = leftData.text;

    if (single_layer.name === "contact A") newData.contact_a = leftData.text;
    if (single_layer.name === "contact B") newData.contact_b = leftData.text;
    if (
      single_layer.name === "website" ||
      single_layer.name === "web_url" ||
      single_layer.name === "website_url"
    )
      newData.website = leftData.text;
    if (single_layer.name === "logo") newData.logo = leftData.src;

    if (single_layer.name === "pamper A") newData.pamper_a = leftData.text;
    if (single_layer.name === "pamper B") newData.pamper_b = leftData.text;
    if (single_layer.name === "pamper C") newData.pamper_c = leftData.text;

    if (single_layer.name === "service A") newData.service_a = leftData.text;
    if (single_layer.name === "service B") newData.service_b = leftData.text;
    if (single_layer.name === "service C") newData.service_c = leftData.text;

    if (single_layer.name === "plan A") newData.plan_a = leftData.text;
    if (single_layer.name === "plan B") newData.plan_b = leftData.text;

    if (single_layer.name === "customer A") newData.customer_a = leftData.text;
    if (single_layer.name === "customer B") newData.customer_b = leftData.text;
    if (single_layer.name === "customer C") newData.customer_c = leftData.text;
    if (single_layer.name === "customer D") newData.customer_d = leftData.text;

    if (single_layer.name === "feel A") newData.feel_a = leftData.text;
    if (single_layer.name === "feel B") newData.feel_b = leftData.text;

    if (single_layer.name === "business A") newData.business_a = leftData.text;
    if (single_layer.name === "business B") newData.business_b = leftData.text;
    if (single_layer.name === "business C") newData.business_c = leftData.text;

    if (single_layer.name === "expert A") newData.expert_a = leftData.text;
    if (single_layer.name === "expert B") newData.expert_b = leftData.text;

    if (single_layer.name === "serve A") newData.serve_a = leftData.text;
    if (single_layer.name === "serve B") newData.serve_b = leftData.text;
    if (single_layer.name === "serve C") newData.serve_c = leftData.text;
    if (single_layer.name === "serve D") newData.serve_d = leftData.text;

    if (single_layer.name === "certified A")
      newData.certified_a = leftData.text;
    if (single_layer.name === "certified B")
      newData.certified_b = leftData.text;
    if (single_layer.name === "certified C")
      newData.certified_c = leftData.text;

    if (single_layer.name === "experienced A")
      newData.experienced_a = leftData.text;
    if (single_layer.name === "experienced B")
      newData.experienced_b = leftData.text;

    if (single_layer.name === "guidance A") newData.guidance_a = leftData.text;
    if (single_layer.name === "guidance B") newData.guidance_b = leftData.text;
    if (single_layer.name === "guidance C") newData.guidance_c = leftData.text;

    if (single_layer.name === "help A") newData.help_a = leftData.text;
    if (single_layer.name === "help B") newData.help_b = leftData.text;

    if (single_layer.name === "spot A") newData.spot_a = leftData.text;
    if (single_layer.name === "spot B") newData.spot_b = leftData.text;

    if (single_layer.name === "assessment A")
      newData.assessment_a = leftData.text;
    if (single_layer.name === "assessment B")
      newData.assessment_b = leftData.text;
    if (single_layer.name === "assessment C")
      newData.assessment_c = leftData.text;

    if (single_layer.name === "window A") newData.window_a = leftData.text;
    if (single_layer.name === "window B") newData.window_b = leftData.text;
    if (single_layer.name === "window C") newData.window_c = leftData.text;

    if (single_layer.name === "demand A") newData.demand_a = leftData.text;
    if (single_layer.name === "demand B") newData.demand_b = leftData.text;
    if (single_layer.name === "demand C") newData.demand_c = leftData.text;

    if (single_layer.name === "meet A") newData.meet_a = leftData.text;
    if (single_layer.name === "meet B") newData.meet_b = leftData.text;

    if (single_layer.name === "spring A") newData.spring_a = leftData.text;
    if (single_layer.name === "spring B") newData.spring_b = leftData.text;
    if (single_layer.name === "spring C") newData.spring_c = leftData.text;
    if (single_layer.name === "spring D") newData.spring_d = leftData.text;

    if (single_layer.name === "holiday A") newData.holiday_a = leftData.text;
    if (single_layer.name === "holiday B") newData.holiday_b = leftData.text;

    if (single_layer.name === "hassels A") newData.hassels_a = leftData.text;
    if (single_layer.name === "hassels B") newData.hassels_b = leftData.text;

    if (single_layer.name === "ladder A") newData.ladder_a = leftData.text;
    if (single_layer.name === "ladder B") newData.ladder_b = leftData.text;
    if (single_layer.name === "ladder C") newData.ladder_c = leftData.text;

    if (single_layer.name === "reach A") newData.reach_a = leftData.text;
    if (single_layer.name === "reach B") newData.reach_b = leftData.text;
    if (single_layer.name === "reach C") newData.reach_c = leftData.text;

    if (single_layer.name === "worry A") newData.worry_a = leftData.text;
    if (single_layer.name === "worry B") newData.worry_b = leftData.text;

    if (single_layer.name === "plumbing A") newData.plumbing_a = leftData.text;
    if (single_layer.name === "plumbing B") newData.plumbing_b = leftData.text;
    if (single_layer.name === "plumbing C") newData.plumbing_c = leftData.text;
    if (single_layer.name === "plumbing D") newData.plumbing_d = leftData.text;
    if (single_layer.name === "plumbing E") newData.plumbing_e = leftData.text;
    if (single_layer.name === "plumbing F") newData.plumbing_f = leftData.text;
    if (single_layer.name === "plumbing G") newData.plumbing_g = leftData.text;

    if (single_layer.name === "quality A") newData.quality_a = leftData.text;
    if (single_layer.name === "quality B") newData.quality_b = leftData.text;
    if (single_layer.name === "quality C") newData.quality_c = leftData.text;

    if (single_layer.name === "money A") newData.money_a = leftData.text;
    if (single_layer.name === "money B") newData.money_b = leftData.text;
    if (single_layer.name === "money C") newData.money_c = leftData.text;
    if (single_layer.name === "money D") newData.money_d = leftData.text;

    if (single_layer.name === "needs A") newData.needs_a = leftData.text;
    if (single_layer.name === "needs B") newData.needs_b = leftData.text;

    if (single_layer.name === "professional A")
      newData.professional_a = leftData.text;
    if (single_layer.name === "professional B")
      newData.professional_b = leftData.text;

    if (single_layer.name === "moments A") newData.moments_a = leftData.text;
    if (single_layer.name === "moments B") newData.moments_b = leftData.text;
    if (single_layer.name === "moments C") newData.moments_c = leftData.text;
    if (single_layer.name === "moments D") newData.moments_d = leftData.text;
    if (single_layer.name === "moments E") newData.moments_e = leftData.text;

    if (single_layer.name === "trained A") newData.trained_a = leftData.text;
    if (single_layer.name === "trained B") newData.trained_b = leftData.text;
    if (single_layer.name === "trained C") newData.trained_c = leftData.text;

    if (single_layer.name === "master A") newData.master_a = leftData.text;
    if (single_layer.name === "master B") newData.master_b = leftData.text;
    if (single_layer.name === "master C") newData.master_c = leftData.text;
    if (single_layer.name === "master D") newData.master_d = leftData.text;

    if (single_layer.name === "need A") newData.need_a = leftData.text;
    if (single_layer.name === "need B") newData.need_b = leftData.text;
    if (single_layer.name === "need C") newData.need_c = leftData.text;

    if (single_layer.name === "work A") newData.work_a = leftData.text;
    if (single_layer.name === "work B") newData.work_b = leftData.text;
    if (single_layer.name === "work C") newData.work_c = leftData.text;
    if (single_layer.name === "work D") newData.work_D = leftData.text;
    if (single_layer.name === "work E")
      newData.work_e = leftData.text.replace("  ", "<br />");

    if (single_layer.name === "suffer A") newData.suffer_a = leftData.text;
    if (single_layer.name === "suffer B") newData.suffer_b = leftData.text;

    if (single_layer.name === "result A") newData.result_a = leftData.text;
    if (single_layer.name === "result B") newData.result_b = leftData.text;
    if (single_layer.name === "result C") newData.result_c = leftData.text;

    if (single_layer.name === "qualified A")
      newData.qualified_a = leftData.text;
    if (single_layer.name === "qualified B")
      newData.qualified_b = leftData.text;
    if (single_layer.name === "qualified C")
      newData.qualified_c = leftData.text;
    if (single_layer.name === "qualified D")
      newData.qualified_d = leftData.text;

    if (single_layer.name === "improve A") newData.improve_a = leftData.text;
    if (single_layer.name === "improve B") newData.improve_b = leftData.text;

    if (single_layer.name === "consultation A")
      newData.consultation_a = leftData.text;
    if (single_layer.name === "consultation B")
      newData.consultation_b = leftData.text;

    if (single_layer.name === "floor A") newData.floor_a = leftData.text;
    if (single_layer.name === "floor B") newData.floor_b = leftData.text;
    if (single_layer.name === "floor C") newData.floor_c = leftData.text;
    if (single_layer.name === "floor D") newData.floor_d = leftData.text;
    if (single_layer.name === "floor E") newData.floor_e = leftData.text;

    if (single_layer.name === "further A") newData.further_a = leftData.text;
    if (single_layer.name === "further B") newData.further_b = leftData.text;

    if (single_layer.name === "provide A") newData.provide_a = leftData.text;
    if (single_layer.name === "provide B") newData.provide_b = leftData.text;
    if (single_layer.name === "provide C") newData.provide_c = leftData.text;

    if (single_layer.name === "everyday A") newData.everyday_a = leftData.text;

    // console.log(newData);
    dispatch(campaignAction.setSlideData({ data: newData }));
    // }

    toggleLeftshow();
    // var previewData = { ...video_data };

    // previewData[active_slide_name] = single_slide_data;
    // console.log(previewData);
  };

  return (
    <>
      {show && (
        <div className="popup_hv">
          <div className="popup_form">
            <form onSubmit={handleSubmit}>
              {/* <h5 className="pb-3">
                <small>
                  <strong className="text-danger">Note : </strong> Edior section
                  not represent final video view
                </small>
              </h5> */}
              <h4 className="pb-2">Control Configuration</h4>
              {!isColor && (
                <>
                  <div className="form-group">
                    <label>
                      Title{" "}
                      <span className="pull-right">
                        Character limit : {length}
                      </span>
                    </label>
                    <Input
                      type="text"
                      inputClass={`form-control ${
                        leftData.text.length >= length && "max-length"
                      }`}
                      value={leftData.text}
                      maxLength={length}
                      onChange={(e) => {
                        setLeftData({ ...leftData, text: e.target.value });
                      }}
                    />
                    {(single_layer.name === "Title" ||
                      single_layer.name === "Description") && (
                      <small className="pull-right">
                        <strong className="text-success">
                          <u>Note</u>:{" "}
                        </strong>{" "}
                        Add double space to break the line in final video
                      </small>
                    )}
                  </div>

                  {/* <div className="form-group">
                    <label>Font Size</label>
                    <Input
                      type="number"
                      inputClass="form-control"
                      // value={leftData.text}
                      value={leftData.fontSize}
                      onChange={(e) =>
                        setLeftData({ ...leftData, fontSize: e.target.value })
                      }
                    />
                  </div> */}
                  <div className="form-group d-none">
                    <label>Font Family</label>
                    <Select
                      options={options}
                      value={options.filter(
                        (option) =>
                          option.value.toLowerCase() ===
                          leftData.fontFamily.toLowerCase()
                      )}
                      className=""
                      onChange={(e) =>
                        setLeftData({ ...leftData, fontFamily: e.value })
                      }
                    />
                  </div>
                </>
              )}
              {isColor && (
                <div className="form-group">
                  <label>Color : {leftData.color}</label>
                  <Input
                    type="color"
                    inputClass="form-control"
                    value={leftData.color}
                    onChange={(e) =>
                      setLeftData({ ...leftData, color: e.target.value })
                    }
                  />
                </div>
              )}
              {/* <div className="form-group">
                <label>Line Height</label>
                <input name="" type="text" className="form-control" />
              </div> */}
              {/* <div className="form-group">
                <label>Opacity</label>
                <input
                  type="range"
                  className="form-control-range w-100"
                  id="formControlRange"
                />
              </div> */}
              <input
                name="submit"
                type="submit"
                value="save"
                className="btn w-100"
              />
            </form>

            <button
              type="button"
              className="close_btn"
              onClick={() => {
                toggleLeftshow();
              }}
            >
              <i className="fa fa-close"></i>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LeftEditor;
